'use strict'
import {onFind} from "../libs/@elements/init-modules-in-scope";
import {removeAttribute, on, addClass, setAttribute, find, closest} from "../libs/@elements/dom-utils";
import fetch from "../libs/@elements/fetch";
import 'url-search-params-polyfill'; // Edge Polyfill

let pendingRequest;

export function init() {
    let loading = find('.js-checkout-sidebar__loading');
    let ajaxCart = find('.js-ajax-cart');

    if(ajaxCart) {
        onFind('.js-ajax-shipping__link', function (link) {
            on('click', function (e) {


                let shippingItem = document.getElementsByClassName('shipping-methods__item');
                for (let i = 0; i < shippingItem.length; i++) {
                    shippingItem[i].classList.remove('shipping-methods__item--selected');
                }

                let parent = closest('.shipping-methods__item', this);
                addClass('shipping-methods__item--selected', parent);

                if (pendingRequest) {
                    pendingRequest.abort();
                    pendingRequest = null;
                }

                e.preventDefault();

                let url = this.getAttribute('href') || throwError(translate('no.action.url'))

                removeAttribute('hidden', loading);

                pendingRequest = fetch(url, {
                    method: 'POST',
                    dataType: 'JSON'
                });
                pendingRequest
                    .then((response) => {
                        return response.clone().json()
                    }).then((response) => {

                    if (response.success) {
                        let html = response.html || throwError(translate('no.html.given'))
                        ajaxCart.innerHTML = html;
                        setAttribute('hidden', true, loading);
                    }
                }).catch((error) => {
                    if (error.name !== 'AbortError') {
                        /*Do error stuff*/
                        console.error(error);
                    }
                    setAttribute('hidden', true, loading);
                });
            }, link)
        });
    }
}